export enum SESSION_EVENT_TYPE {
  STEP = 'Step',
  EXECUTION_TIME = 'ExecutionTime',
  NOTIFICATION = 'Notification',
  SESSION = 'Session',
  WHISPER = 'WhisperToAgent',
  TRANSCRIPT = 'Transcript',
  /* Custom type for user provided templates */
  EVENT_TEMPLATE = 'EventTemplate',
}

export enum SESSION_CHANGE_TYPE {
  MANAGE_CLAIM = 'manageClaim',
  MANAGE_TAGS = 'manageTags',
  MANAGE_RULE_TAGS = 'manageRuleTags',
  NEEDS_ACTION = 'needsAction',
}

export enum SESSION_EVENT_MULTIMEDIA_ITEM_TYPE {
  AUDIO = 'Audio',
  IMAGE = 'Image',
  FILE = 'File',
}

export enum SESSION_EVENT_VALUE_ACTION_TYPE {
  CALL_START = 'Call Start',
  CALL_END = 'Call End',
  CALL_TRANSFER = 'Call Transfer',
  CONFERENCE_JOIN = 'Conference Join',
  CONFERENCE_LEAVE = 'Conference Leave',
}
